export default "__VITE_ASSET__mdV7AGAP__"